module.exports = "/lucky-balls/img/infobox/info_Box_022.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_022.png
// module id = 1087
// module chunks = 0